import React, { useEffect } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'

interface ICPProps {
	requestConfigTP: () => RequestConfigTP<void>
	onCancel: () => void
}

/**
 * Botão para cancelar execução de QA/QC.
 */
export function ButtonCancelQAQCCP(props: ICPProps): JSX.Element {
	const cancelRequest = useRequest<void>('none')
	useEffect(onCancelRequestChange, [cancelRequest.isAwaiting])

	function cancel(): void {
		cancelRequest.runRequest(props.requestConfigTP())
	}

	function onCancelRequestChange(): void {
		if (
			!RequestUtils.isValidRequestReturn(
				cancelRequest,
				'Erro ao cancelar execução',
				'Execução cancelada com sucesso',
				true,
			)
		)
			return
		props.onCancel()
	}

	return (
		<ButtonCP
			size={'small'}
			type={'danger'}
			icon={'close'}
			confirmMsg={'Deseja cancelar esta execução de QA/QC?'}
			onClick={cancel}
			loading={cancelRequest.isAwaiting}
		/>
	)
}
